import { Col, Row } from "antd";
import "./dashboard.css";
import { motion } from "framer-motion";
import { useState } from "react";
import { HeaderBar } from "../components/Dashboard/HeaderBar";
import TotalFilesCard from "../components/Dashboard/SuspendTeamDashboard/TotalFilesCard";
import TotalResolvedFilesCard from "../components/Dashboard/SuspendTeamDashboard/TotalResolvedFilesCard";
import InfoCards from "../components/Dashboard/SuspendTeamDashboard/InfoCards";

export const SuspendTeamDashboard = () => {
  const [dateRange, setDateRange] = useState<any>([]);
  const roleName = localStorage.getItem("roleName");

  return (
    <div
      style={{ background: "#F0F0F0", padding: "30px" }}
      className="acm-dashboard"
    >
      <motion.div
        initial={{ y: 200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 300, opacity: 0 }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 40,
        }}
        className="acm-dashboard"
      >
        <HeaderBar setDateRange={setDateRange} thisMonth={true} />

        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col sm={24} md={24} lg={12}>
            <TotalFilesCard
              roleName={roleName ?? ""}
              title="Total Files"
              dateRange={dateRange}
            />
          </Col>
          <Col sm={24} md={24} lg={12}>
            <Row gutter={[16, 16]}>
              <Col xs={24}>
                <TotalResolvedFilesCard
                  roleName={roleName ?? ""}
                  title="Total Resolved Files"
                  dateRange={dateRange}
                />
              </Col>
              {roleName === "SUSPEND_TEAM_MANAGER" && (
                <Col xs={24}>
                  <InfoCards roleName={roleName ?? ""} dateRange={dateRange} />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        {roleName !== "SUSPEND_TEAM_MANAGER" && (
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col xs={24}>
              <InfoCards roleName={roleName ?? ""} dateRange={dateRange} />
            </Col>
          </Row>
        )}
      </motion.div>
    </div>
  );
};
